module.exports = __webpack_public_path__ + "img/電気回路_1_7_4.1ebad8ff.jpeg";